'use strict';

var _ = require('lodash');
var DashboardSummaryPanelController = function DashboardSummaryPanelController($scope, $filter) {
  var rmNumberFormat = $filter('rmNumberFormat');
  $scope.summary = {};
  $scope.hasData = false;
  $scope.summaryLabel = '';
  function yoyFormula(v1, v2, isLoadFactorMetric) {
    return isLoadFactorMetric ? v2 - v1 : v1 ? (v2 / v1 - 1) * 100 : 0;
  }
  function calculateYOY(mode, isLoadFactorMetric) {
    switch (mode) {
      case 'BUDGET':
        return yoyFormula($scope.summary.budget, $scope.summary.expected, isLoadFactorMetric);
      case 'TARGET':
        return yoyFormula($scope.summary.target, $scope.summary.expected, isLoadFactorMetric);
      default:
        return yoyFormula($scope.summary.finalRef, $scope.summary.expected, isLoadFactorMetric);
    }
  }
  function getSummaryLabel(mode) {
    switch (mode) {
      case 'BUDGET':
        return 'Budget';
      case 'TARGET':
        return 'Target';
      default:
        return 'YOY';
    }
  }
  function getReferenceLabel(mode) {
    switch (mode) {
      case 'LY':
        return 'LY';
      case 'SEASONAL_AVG':
        return ($scope.isLoadFactorMetric() ? 'Overbooking' : 'Demand') + ' Season Avg';
      default:
        return '';
    }
  }
  $scope.recalculateSummaryPanel = function (data) {
    $scope.summary.current = data.current;
    $scope.summary.expected = data.expected;
    $scope.summary.currentRef = data.currentRef;
    $scope.summary.finalRef = data.finalRef;
    $scope.summary.budget = data.budget;
    $scope.summary.target = data.target;
    $scope.hasData = _.reduce(_.omit($scope.summary, 'yoy'), function (sum, value) {
      return sum + (value ? value : 0) || 0;
    });
    $scope.summaryLabel = getSummaryLabel($scope.screenState.aggregationMode);
    $scope.referenceLabel = getReferenceLabel($scope.screenState.aggregationMode);
    $scope.summary.yoy = calculateYOY($scope.screenState.aggregationMode, $scope.isLoadFactorMetric()).toFixed(2);
  };
  $scope.isReferenceMode = function () {
    return $scope.screenState.aggregationMode === 'LY' || $scope.screenState.aggregationMode === 'SEASONAL_AVG';
  };
  $scope.isBudgetMode = function () {
    return $scope.screenState.aggregationMode === 'BUDGET';
  };
  $scope.isTargetMode = function () {
    return $scope.screenState.aggregationMode === 'TARGET';
  };
  $scope.isLoadFactorMetric = function () {
    return $scope.screenState.selectedMetric.id === 'loadFactor';
  };
  $scope.convertYoyValueToDisplay = function () {
    return Math.abs($scope.summary.yoy);
  };
  $scope.formatNumber = function (value) {
    return rmNumberFormat(value, $scope.isLoadFactorMetric() ? 'PERCENTAGE_SHORT' : 'NUMBER_DECIMAL');
  };
};
DashboardSummaryPanelController.$inject = ['$scope', '$filter'];
module.exports = DashboardSummaryPanelController;